import { RoutedViewProps } from "@my-dld/utils/UrlUtils";
import React, { Component } from "react";
import Strings, { LVStrings } from "@my-dld/assets/strings";
import RVContext from "../../RVContext";
import { EvalMode, PTypes, RVEnvironment, RVMode, RVPicketItem, RVPropertyType, RVSearchType, SearchMode } from "../../api/entities";
import { getSearchModes, getSupportedRVMode, populateSearchOptions } from "../../RVUtils";
import PickerInput from "@my-dld/components/Form/PickerInput";
import { LocaleUtil } from "@eres/core";
import { OwnedForm } from "./Forms/OwnedForm";
import { DefaultSearchOption } from "../../api/api";
import { checkNonEmpty } from "@eres/ejari-web/utils";
import { IPForm } from "./Forms";
import { ErrorContainer } from "@eres/forms";
import { LandForm } from "./Forms/LandForm";
import { DMForm } from "./Forms/DMForm";
import { ContractForm } from "./Forms/ContractForm";
import { DewaForm } from "./Forms/DewaForm";
import { TitleDeedForm } from "./Forms/TitleDeedForm";
import { navigateWithInParent } from "@my-dld/utils/StoreUtils";

interface Prop extends RoutedViewProps {

}

interface ValueState {
	modeVal?: RVPicketItem;
	propertyTypeVal?: RVPicketItem;
	searchTypeVal?: RVPicketItem;
}

interface State extends ValueState {
	isLoading: boolean;
	env?: RVEnvironment;
	disableMode: boolean;
	disablePPTY: boolean;
	sm: "search" | "view";
	errorContainer: ErrorContainer;
}

class SearchProperty extends Component<Prop, State> {
	static contextType = RVContext;
	context!: React.ContextType<typeof RVContext>;
	form = React.createRef<any>();

	constructor( props: Prop ) {
		super( props );
		this.state = {
			sm: "search",
			isLoading: false,
			disableMode: false,
			disablePPTY: false,
			errorContainer: {},
		};
	}

	static getDerivedStateFromProps( nextProps: Readonly<Prop>, prevState: State ): Partial<State> {
		return {};
	}

	componentDidMount(): void {
		const update: Partial<State> = {};
		if ( this.context.env && this.context.env.mode ) {
			update.disableMode = true;
			update.modeVal = EvalMode.find( x => {
				return x.Identity === this.context.env.mode;
			} );
		}
		if ( this.context.env && this.context.env.propertyType != undefined ) {
			update.disablePPTY = true;
			update.propertyTypeVal = PTypes.find( x => {
				return x.Identity === this.context.env.propertyType;
			} );
		}
		this.setState( update as State );
	}

	componentDidUpdate( prevProps: Readonly<Prop>, prevState: Readonly<State>, snapshot?: any ): void {
		const { modeVal, propertyTypeVal, searchTypeVal } = this.state;

		const env = { ...this.context.env };
		env.mode = modeVal?.Identity;
		env.propertyType = propertyTypeVal?.Identity;
		let searchTypes = getSearchModes( {
			...env,
		} );
		const update: Partial<State> = {};
		if ( searchTypeVal ) {
			if ( searchTypes.indexOf( searchTypeVal.Identity ) === -1 ) {
				update.searchTypeVal = undefined;
			}
			if ( env.mode !== RVMode.POA &&
				propertyTypeVal?.Identity === RVPropertyType.LAND &&
				searchTypeVal === { Identity: RVSearchType.LandNumber, ...LVStrings.land_no, }
			) {
				if ( prevState.sm === "search" ) {
					// update.sm = "view";
				}

			} else if ( prevState.sm === "view" ) {
				update.sm = "search";
			}
		}
		if ( Object.keys( update ).length > 0 )
			this.setState( update as State );
	}

	render() {
		const {
			modeVal, propertyTypeVal, searchTypeVal, errorContainer, disableMode,
			disablePPTY, sm,
		} = this.state;
		const env = { ...this.context.env };
		if ( modeVal ) {
			env.mode = modeVal.Identity;
		}
		if ( propertyTypeVal != undefined ) {
			env.propertyType = propertyTypeVal.Identity;
		}
		let modes = getSupportedRVMode( {
			...env,
			mode: this.context.env.mode,
		} );
		let searchTypes = getSearchModes( {
			...env,
		} );

		const allowedModes = EvalMode.filter( x => {
			return modes.indexOf( x.Identity ) !== -1;
		} );
		const allowedSearch = SearchMode.filter( x => {
			return searchTypes.indexOf( x.Identity ) !== -1;
		} );
		const formProps = {
			env: env,
			ref: this.form,
			searchType: searchTypeVal,
		};
		const kvProp = { inputClassName: "form-control", holder: this, containerClassName: "col-md-6 form-group" };
		return <div className="tender-registration-form" id="valuationFormCompany">
			<div className="card">
				<div className="card-header">
					<span>{ Strings.select_properties_for_valuation }</span>
				</div>
				<div className="card-body">
					<div className="mandatory-field-info">
						<small>{ Strings.mandatory_fields_note }</small>
					</div>
					<div className="row">
						<div className="col-md-4">
							<PickerInput
								{ ...kvProp }
								label={ Strings.i_want_rental_valuation_on }
								id={ "modeVal" }
								items={ allowedModes }
								formatter={ item => LocaleUtil.getLocalValue( item ) }
								toIdentifier={ ( item: RVPicketItem ) => item.Identity + "" }
								containerClassName="form-group field-style select-control"
								required={ true }
								error={ errorContainer.modeVal }
								disabled={ disableMode }
							/>
						</div>
						{
							modeVal &&
							<div className="col-md-4">
								<PickerInput
									{ ...kvProp }
									label={ Strings.property_type }
									id={ "propertyTypeVal" }
									items={ PTypes }
									formatter={ item => LocaleUtil.getLocalValue( item ) }
									toIdentifier={ ( item: RVPicketItem ) => item.Identity + "" }
									containerClassName="form-group field-style select-control"
									required={ true }
									error={ errorContainer.propertyTypeVal }
									disabled={ disablePPTY }
								/>
							</div>
						}
					</div>
				</div>
			</div>
			{
				propertyTypeVal &&
				<div className="card">
					<div className="card-header">
						<span>{ Strings.search }</span>
					</div>
					<div className="card-body">
						<div className="row">
							<div className="col-md-4">
								<PickerInput
									{ ...kvProp }
									label={ Strings.search_by }
									id={ "searchTypeVal" }
									items={ allowedSearch }
									formatter={ item => LocaleUtil.getLocalValue( item ) }
									toIdentifier={ ( item: RVPicketItem ) => item.Identity + "" }
									containerClassName="form-group field-style select-control"
									required={ true }
									error={ errorContainer.searchTypeVal }
								/>
							</div>
						</div>
						{ sm === "search" &&
							<React.Fragment>
								{ searchTypeVal?.Identity === RVSearchType.Participant && <OwnedForm { ...formProps }/> }
								{ searchTypeVal?.Identity === RVSearchType.LandNumber && <LandForm { ...formProps }/> }
								{ searchTypeVal?.Identity === RVSearchType.DMNumber && <DMForm { ...formProps }/> }
								{ searchTypeVal?.Identity === RVSearchType.EjariNumber && <ContractForm { ...formProps }/> }
								{ searchTypeVal?.Identity === RVSearchType.Dewa && <DewaForm { ...formProps }/> }
								{ searchTypeVal?.Identity === RVSearchType.TitleDeed && <TitleDeedForm { ...formProps }/> }
							</React.Fragment>
						}
					</div>
				</div>
			}
			<div className="rental-valuation-btns">
				<button
					className="btn btn-grey btn_style1 me-2" data-bs-target="#completedProjectsModal"
					onClick={ () => {
						this.props.history.goBack();
					} }
					data-bs-toggle="modal" type="button">{ Strings.back }
				</button>
				<button
					className="btn btn_1 btn_style1 btn-sm" data-bs-target="#completedProjectsModal"
					onClick={ this.onSearch }
					data-bs-toggle="modal" type="button">
					{ Strings.search }
				</button>
			</div>
		</div>;
	}

	onSearch = () => {
		const {
			modeVal, propertyTypeVal,
		} = this.state;
		const opts = { ...DefaultSearchOption };
		const env = { ...this.context.env };
		if ( modeVal ) {
			env.mode = modeVal.Identity;
		}
		if ( propertyTypeVal != undefined ) {
			env.propertyType = propertyTypeVal.Identity;
		}
		let isValid: boolean = true;
		const errorContainer: ErrorContainer = {};
		isValid = checkNonEmpty( this.state, "modeVal", errorContainer ) && isValid;
		isValid = checkNonEmpty( this.state, "propertyTypeVal", errorContainer ) && isValid;
		isValid = checkNonEmpty( this.state, "searchTypeVal", errorContainer ) && isValid;
		if ( isValid ) {
			opts.searchTypeId = this.state.searchTypeVal?.Identity!;
			populateSearchOptions( opts, env );
			if ( this.form.current ) {
				const form: IPForm = this.form.current as IPForm;
				isValid = form.validate( opts, env );
				if ( isValid ) {
					form.updateParams( opts, env );
					navigateWithInParent( "rentalvaluation", "properties", undefined, { opts: opts, env: env } );
				}
			} else {
				navigateWithInParent( "rentalvaluation", "properties", undefined, { opts: opts, env: env } );
			}

		}
		this.setState( {
			errorContainer: errorContainer,
		} );
	};
}

export default SearchProperty;
